import { Button, ButtonProps } from "@mui/material";
import { FC } from "react";

interface SalifyOutlinedButtonProps {
  text: string | undefined;
  buttonProps: ButtonProps;
}

const SalifyOutlinedButton: FC<SalifyOutlinedButtonProps> = ({ text, buttonProps }) => {
  return (
    <Button {...buttonProps} color={buttonProps?.color || "primary"} variant="outlined">
      {text}
    </Button>
  );
};

SalifyOutlinedButton.displayName = "SalifyOutlinedButton";

export default SalifyOutlinedButton;
